// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"8e98b985","113":"0c9be4b0","142":"dbfb346d","358":"7905d0dc","438":"afabc95e","454":"518a80af","538":"af15b119","648":"790a3bd2"}[chunkId] + ".chunk.js";
};